import React from 'react'
import { Card, ListGroup } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import useRecentOrganizationSearches from 'hooks/use-recent-organization-searches'
import useRecentOrganizations from 'hooks/use-recent-organizations'

const OrganizationsSidebar: React.FC = () => {
  const history = useHistory()
  const { recentSearches } = useRecentOrganizationSearches()
  const { recentOrganizations } = useRecentOrganizations()

  const handleSearchClick = (query: string) => {
    history.push(`/organizations?query=${encodeURIComponent(query)}`)
  }

  const handleOrganizationClick = (organizationId: string) => {
    history.push(`/organizations/${organizationId}`)
  }

  return (
    <div className="organizations-sidebar">
      <Card className="mb-3">
        <Card.Header className="text-light" style={{ backgroundColor: '#444' }}>
          <h6 className="mb-0">Your Recent Organization Searches</h6>
        </Card.Header>
        <Card.Body className="p-0">
          {recentSearches.length === 0 ? (
            <div className="text-muted p-3">
              <small>No recent searches</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {recentSearches.slice(0, 5).map((search, index) => (
                <ListGroup.Item
                  key={index}
                  className="d-flex align-items-center justify-content-between"
                  action
                  onClick={() => handleSearchClick(search.query)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="text-truncate">{search.query}</span>
                  <ion-icon
                    name="search-outline"
                    style={{ fontSize: '16px' }}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>

      <Card>
        <Card.Header className="text-light" style={{ backgroundColor: '#444' }}>
          <h6 className="mb-0">Recently Viewed Organizations</h6>
        </Card.Header>
        <Card.Body
          className="p-0"
          style={{ maxHeight: '300px', overflowY: 'auto' }}
        >
          {recentOrganizations.length === 0 ? (
            <div className="text-muted p-3">
              <small>No recently viewed organizations</small>
            </div>
          ) : (
            <ListGroup variant="flush">
              {recentOrganizations.map((org) => (
                <ListGroup.Item
                  key={org.id}
                  className="d-flex align-items-center justify-content-between"
                  action
                  onClick={() => handleOrganizationClick(org.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center text-truncate">
                    <div className="text-truncate">
                      <div className="fw-bold">{org.name}</div>
                      <small className="text-muted">ID: {org.id}</small>
                    </div>
                  </div>
                  <ion-icon
                    name="chevron-forward-outline"
                    style={{ fontSize: '16px' }}
                  />
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

export default OrganizationsSidebar
